import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';
import { ITemplate } from '~/utils/interface/template';
import { handleGetTemplates } from './templateThunk';

export interface TemplateState {
  templates: Array<ITemplate>;
  filter: IFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  selectedIds: Array<string>;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IFilter {
  page?: number;
  limit?: number;
  sort?: Array<SortField>;
  type?: string;
}

const initialState: TemplateState = {
  templates: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    sort: [],
    type: '',
  },
  selectedIds: [],
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
      if (!state.openAlertDelete) {
        state.menuSelectedId = undefined;
      }
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetTemplates.pending, (_state, _action) => {})
      .addCase(handleGetTemplates.fulfilled, (state, action) => {
        state.templates = [...action.payload.responses];
        state.currentPage = action.payload.pagination.page;
        state.totalPages = action.payload.pagination.totalPages;
        state.needRefreshData = false;
      })
      .addCase(handleGetTemplates.rejected, (_state, _action) => {});
  },
});

export const templateActions = templateSlice.actions;

const templateReducer = templateSlice.reducer;
export default templateReducer;
